import { render } from "./ProfilePhoto.vue?vue&type=template&id=323fa8b4&scoped=true"
import script from "./ProfilePhoto.vue?vue&type=script&lang=js"
export * from "./ProfilePhoto.vue?vue&type=script&lang=js"

import "./ProfilePhoto.vue?vue&type=style&index=0&id=323fa8b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-323fa8b4"]])

export default __exports__